import React, { Component } from "react";
import { getWebData } from "../../utils/common.utils";
import { MdOutlinePrivacyTip } from "react-icons/md";

export default class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.websiteData = getWebData();
  }

  componentDidMount() {
    this.props.showOrHideNav(true);
  }

  render() {
    const policies =
      this.websiteData?.STATIC_PAGE?.PRIVACY_POLICY?.SET_UP_PRIVACY_POLICY?.split("&&");

    return (
      <section className="body-section">
        <div className="p-3 d-flex flex-column mx-auto notifications">
          <div className="row text-center">
            <div className="col-12">
              <h1 className="fs-20 fw-bold text-white mb-2 mt-3">
                {" "}
                <MdOutlinePrivacyTip style={{ color: "white" }} /> Privacy Policy
              </h1>
            </div>
          </div>
          <div className="row ">
            <ol className="text-white">
              {policies?.map((policy, i) => {
                return <li key={i}>{policy}</li>;
              })}
            </ol>
          </div>
        </div>
      </section>
    );
  }
}
